import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { BookApplicationFormType } from '../NewApplicationPage/types';
import { NewRepresentativeApplicationPage } from '../NewRepresentativeApplicationPage/NewRepresentativeApplicationPage';

export const EditRepresentativeApplicationPage = () => {
  const { id } = useParams();
  const [currentApplicationState, setCurrentApplication] = useState<BookApplicationFormType>();

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const currentApplicationResponse = await api.get<BookApplicationFormType>(endpoints.getApplicationById(id));

          setCurrentApplication(currentApplicationResponse.data);
        } catch (err) {}
      })();
    }
  }, [id]);

  return (
    <>
      <NewRepresentativeApplicationPage newRepresentativeApplication={currentApplicationState} edit />
    </>
  );
};
